<div class="container">
  @switch (receivedType) {
    @case ('objective') {
      <div i18n
        >Soll das Ziel <span class="bold">{{ received.name }}</span> diesem Projekt hinzugefügt werden?</div
      >
    }
    @case ('alternative') {
      <div i18n
        >Soll die Alternative <span class="bold">{{ received.name }}</span> diesem Projekt hinzugefügt werden?</div
      >
    }
  }

  <div>
    <button mat-icon-button class="yes" (click)="add()" data-cy="accept-transfer"><mat-icon>check</mat-icon></button>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </div>
</div>
